export const API_URL = process.env.REACT_APP_API_URL;
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
// export const AICRM_API_URL = process.env.REACT_APP_AICRM_API_URL;
